import React from "react";
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { breakpoints } from '../../utils/styles';
import Button from "../Button";
import IeCardFront from "./IeCardFront";
import IeCardBack from "./IeCardBack";

const Cards = styled.div`
  margin: 3em 0 1em;

  @media screen and (min-width: ${breakpoints.desktop}px) {
    margin-bottom: 3em;
    
    & > div {
      display: inline-block;
      margin: 0 1em;
      max-width: 45%;
    }
  }
`;

const StyledButton = styled(Button)``;

const SuccessContainer = styled.div`
    text-align: center;
  
    & > i { font-size: 4rem; margin-bottom: 0.5em; }
    & > h1, & > h2 { color: var(--text-primary); font-weight: 700; }
    & > ${StyledButton} {
      margin: 1.5em 0;
      padding-left: 1.5em;
      padding-right: 1.5em;
      width: auto;
  
      @media screen and (min-width: ${breakpoints.desktop}px) {
        margin: 1em 0;
      }
    }
    & > p { line-height: 1.75; margin: 1em 0; }
  `;

function IeSignUpSuccessMessage(props) {
    return <SuccessContainer className="fade-in">
        <i class="fa-light fa-circle-check"></i>
        <h1>¡Felicidades!</h1>
        <h2>{props.title}</h2>
        {props.cardData
            ? <Cards>
              <IeCardFront data={props.cardData} flip={false} />
              <IeCardBack data={props.cardData} flip={true} />
            </Cards>
            : ''}
        <StyledButton primary className="d-inline-block d-md-none" to="/usuario/loop/tarjeta">Ver tu tarjeta</StyledButton>
        {props.content}
        <p>Sigue disfrutando <strong>#LaMagiaDelCine</strong></p>
        <StyledButton primary to="/">Ver cartelera</StyledButton>
    </SuccessContainer>;
}

IeSignUpSuccessMessage.StyledButton = StyledButton;
export default IeSignUpSuccessMessage;